export const SLOT_DATA_TYPE_CAPTURE_BY_AI = "custom";
export const SLOT_DATA_TYPE_REGEX = "regex";
export const SLOT_DATA_TYPE_VALUES = "values";
export const SLOT_DATA_TYPE_ANY = "any";
// Filled by a doc capture step rather than typed by the user. The value is an
// object - { raw, data } - not a scalar, so it is not offered
// as a validation type for free-text answers.
export const SLOT_DATA_TYPE_DOCUMENT = "document";

export const SLOT_DATA_TYPES = [
    { label: SLOT_DATA_TYPE_CAPTURE_BY_AI, value: SLOT_DATA_TYPE_CAPTURE_BY_AI },
    { label: SLOT_DATA_TYPE_REGEX, value: SLOT_DATA_TYPE_REGEX },
    { label: SLOT_DATA_TYPE_VALUES, value: SLOT_DATA_TYPE_VALUES },
    { label: "number", value: "number" },
    { label: "boolean", value: "boolean" },
    { label: "email", value: "email" },
    { label: "age", value: "age" },
    { label: "date", value: "date" },
    { label: "datetime", value: "datetime" },
    { label: SLOT_DATA_TYPE_DOCUMENT, value: SLOT_DATA_TYPE_DOCUMENT },
    { label: SLOT_DATA_TYPE_ANY, value: SLOT_DATA_TYPE_ANY },
]

